<template>
  <section>
    <table class="table is-striped" v-if="rows.length">
      <thead>
        <th>Currency</th>
        <th v-for="col in columns" :key="col.key">{{ col.label }}</th>
        <th></th>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index">
          <td>
            <b-select v-model="row.currency.data" :disabled="isLocked(row)" placeholder="Currency">
              <option value="" disabled>Currency</option>
              <option v-for="choice in currencyChoices" :value="choice.value" :key="choice.value">
                {{ choice.label }}
              </option>
            </b-select>
          </td>
          <td v-for="col in columns" :key="col.key">
            <b-input v-model="row[col.key].data" />
          </td>
          <td>
            <button v-if="!isLocked(row)" class="button is-primary" type="button" @click="removeRow(index)">
              <b-icon icon="minus" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="button is-primary" type="button" @click="addRow">
      <b-icon icon="plus" />
    </button>
  </section>
</template>

<script>
export default {
  name: 'bonus-currency-map',
  props: ['value', 'fieldErrors', 'fieldPayload', 'type'],
  computed: {
    rows() {
      // A CollectionType field arrives bimodally (see ProjectBundle\Normalizer\FormNormalizer):
      // a bare array of row objects when populated, or an object {data:[], prototype} when empty.
      // We iterate only the populated (array) form; addRow/removeRow below handle the flip.
      return Array.isArray(this.value) ? this.value : []
    },
    columns() {
      return [{ key: 'value', label: 'Threshold (minor units)' }]
    },
    currencyChoices() {
      // The prototype carries currency choices only while the field is empty (0 rows); once rows
      // exist the prototype is gone and each row re-emits an identical choices list, so we fall
      // back to the first row's choices.
      const proto = this.value && this.value.prototype
      const src = proto ? proto.currency : this.rows[0] && this.rows[0].currency
      return (src && src.choices) || []
    },
  },
  methods: {
    isLocked(row) {
      return this.type === 'dust' && row.currency && row.currency.data === 'default'
    },
    emptyRow() {
      // Seed the new row's currency choices from the prototype (empty map) or the existing rows
      // (populated map): addRow flips {data:[],prototype} to a bare array and would otherwise drop
      // the prototype's choices, leaving the dropdown empty on the first row of an empty map.
      const row = { currency: { data: '', choices: this.currencyChoices } }
      this.columns.forEach(col => {
        row[col.key] = { data: '' }
      })
      return row
    },
    addRow() {
      if (!Array.isArray(this.value)) {
        this.$emit('input', [this.emptyRow()])
      } else {
        this.value.push(this.emptyRow())
      }
    },
    removeRow(index) {
      this.value.splice(index, 1)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Form/Custom/BonusCurrencyMap.vue